<template>
  <Header />
  <NuxtPage />
  <Footer />
</template>

<script setup lang="ts">
import type { ICurrencyCountry, ICurrencyItem } from "@/types/currencyItem";
import type { AuthStore } from "~/types/authStore";
import { useJsonLdSchema } from "~/composables/useJsonLd";

interface IUserStore {
  value: AuthStore;
}

const runtimeConfig = useRuntimeConfig();
const { $auth } = useNuxtApp();
const auth = $auth as IUserStore;

const userStore = useUserStore();
userStore.set(auth.value);
userStore.setSocialRequired(auth.value.social);

const wooStore = useWooStore();
wooStore.setCartTotal(auth.value.totalItem);
wooStore.setCart(auth.value.carts);
wooStore.setId(auth.value.wcId);
wooStore.setCurrentCountry(auth.value.currentCountry);

if (auth.value.notice && Object.keys(auth.value.notice).length > 0) {
  wooStore.setNotification(auth.value.notice.type, auth.value.notice.message);
}

const setCookieClient = (name: string, value: string) => {
  const cookie = useCookie(name, {
    maxAge: 30 * 24 * 60 * 60,
    path: "/",
    secure: true,
    sameSite: "strict",
  });

  cookie.value = value;
};

onMounted(() => {
  const eventBus = useEventBus();

  const logoutHandler = () => {
    userStore.logout();
  };

  const miniCartHandler = async (response?: any) => {
    if (response) {
      const { eventCart } = await import("~/assist/MiniCart");
      eventCart(response.html, response.total);
    }
  };

  const syncMiniCart = async () => {
    const { getMiniCart } = await import("~/assist/MiniCart");
    getMiniCart();
  };

  eventBus.on("auth:logout", logoutHandler);
  eventBus.on("cart:minicart:update", miniCartHandler);
  eventBus.on("cart:minicart:sync", syncMiniCart);

  onUnmounted(() => {
    eventBus.off("auth:logout", logoutHandler);
    eventBus.off("cart:minicart:update", miniCartHandler);
    eventBus.off("cart:minicart:sync", syncMiniCart);
  });
});

useJsonLdSchema();
</script>
